import * as array from './array'
import * as constant from './constant'
import * as math from './math'
import * as pkg from './pkg'
// export { test } from './array/arrayEqual'

export * from './array'
export * from './constant'
export * from './math'
export * from './pkg'
/**
 * @desc 工具函数
 */
export {
  array,
  constant,
  math,
  pkg,
}

export const utils = {
  ...pkg,
  ...array,
  ...math,
  ...constant,
}

export default utils

export {
  default as validate,
} from './validate'

// 如果需要，也可以单独导出每个模块
// export { default as base } from './servers/base/api/index';
// export { default as supplier } from './servers/supplier/api/index';
// export { default as merchant } from './servers/merchant/api/index';
